import { CircularProgress } from "@mui/material";
import { useAuth } from "react-oidc-context";
import { Redirect, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ROUTES } from "../../core/constants/Routes";

const LoginCallback = () => {
  const auth = useAuth();
  const location = useLocation();

  const from =
    (location.state as { from?: Location })?.from?.pathname ||
    ROUTES.INITIAL_ROUTE;

  useEffect(() => {
    if (auth.isAuthenticated && auth.user) {
      localStorage.setItem("auth-token", auth.user.access_token);
    }
  }, [auth.isAuthenticated, auth.user]);

  if (auth.isLoading) {
    return <CircularProgress />;
  }

  if (auth.error) {
    console.error(auth.error);
    return <Redirect to={ROUTES.INITIAL_ROUTE} />;
  }

  if (auth.isAuthenticated) {
    return <Redirect to={from} />;
  }

  return null;
};

export default LoginCallback;
